export class ProjectStatesDef {
  public static readonly FINALIZATION_STATE_NEW: number = 0;
  public static readonly FINALIZATION_STATE_REQUESTED: number = 1;
  public static readonly FINALIZATION_STATE_PREPARATION: number = 2;
  public static readonly FINALIZATION_STATE_PDM_EXPORT_DONE: number = 3;
  public static readonly FINALIZATION_STATE_LEGACY_PROJECT_EXPORT_DONE: number = 4;
  public static readonly FINALIZATION_STATE_ORDERED: number = 5; // normally comes after project was requested
  public static readonly FINALIZATION_STATE_FINALIZED_WITHOUT_PDM: number = 6; // normally comes after project was requested
}
